import React from "react";
import ReactDOM from "react-dom/client";
import { Toaster, toast } from "react-hot-toast";

import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { AuthProvider } from "./contexts/AuthContext";
import { CompanyProvider } from "./contexts/CompanyContext";

window.addEventListener("unhandledrejection", (event: PromiseRejectionEvent) => {
  const reason = event.reason as any;
  const message =
    reason?.message || (typeof reason === "string" ? reason : "An unexpected error occurred.");
  const text =
    message === "Network Error" ? "Network error. Please check your connection." : message;
  toast.error(text);
  event.preventDefault();
});

window.addEventListener("error", (event: ErrorEvent) => {
  if (event.error) {
    const message = event.error.message || "An unexpected error occurred.";
    toast.error(message);
    event.preventDefault();
  }
});

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
  // <React.StrictMode>
  <AuthProvider>
    <CompanyProvider>
      <App />
      <Toaster position='top-right' />
    </CompanyProvider>
  </AuthProvider>,
  // </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
